import axios from 'axios'
// import QS from 'qs'

axios.defaults.baseURL = '/api'
axios.defaults.timeout = 15000
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
axios.interceptors.request.use(
    config => {
        var token = window.sessionStorage.getItem('token')
        config.headers.token = token
        return config;
    },
    error => {
        return Promise.error(error);
    })
var uploadRequest = axios.create({
    baseURL: '/api',
    timeout: 10000,
    headers: { 'Content-Type': 'multipart/form-data' }
})
export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        }).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err.data)
        })
    });
}
export function post(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, JSON.stringify(params))
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}
export function upload(url, file) {
    console.log(url)
    return new Promise((resolve, reject) => {

        uploadRequest.post(url, file)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}